/**
 *
 * PluginIcon
 *
 */

import React from 'react';
import Upload from '@strapi/icons/Upload';
const PluginIcon = () => /*#__PURE__*/React.createElement(Upload, null);
export default PluginIcon;